import { Injectable } from '@angular/core';
import { DataServiceBase } from '../../../core/framework/data-service-base';
import { DataTaskService } from '../../../core/services/data-task.service';
import { DataTask0To99Service, Dt53Parms, MenuItem } from '../../../core/services/datatask/data-task-0-to-99.service';

export interface SettingsGetResult {
    filterval?: string;
}

@Injectable({
  providedIn: 'root'
})
export class SettingsService extends DataServiceBase {

    constructor(private datatask: DataTaskService, private dataTask0To99Service: DataTask0To99Service) {
        super();
    }

    public async getSettings(): Promise<SettingsGetResult[]> {
        return await this.datatask.Post(1020);
    }

    public async listSettings(parms: Dt53Parms): Promise<MenuItem[]> {
        return await this.dataTask0To99Service.dt53(parms);
    }
}
